import { TFunction } from "next-i18next";
import { UTSLocale } from "@smile2impress/attraction-constants";

const content = (t: TFunction, _locale: UTSLocale) => {
    return {
        messageWithTwoFingerGesture: t("map:messageWithTwoFingerGesture"),
        messageWithUseCmdToZoom: t("map:messageWithUseCmdToZoom"),
        messageWithUseCtrlToZoom: t("map:messageWithUseCtrlToZoom"),
        flagshipLabel: t("map:flagshipLabel"),
        ctaLabel: t("map:ctaLabel"),
        moreInformationLabel: t("map:moreInformationLabel"),
        searchBarTitle: t("map:searchBarTitle"),
        searchBarPlaceholder: t("map:searchBarPlaceholder"),
        locationIsNotFoundError: t("map:locationIsNotFoundError"),
        searchError: t("map:searchError"),
    };
};

export default content;
